import React, { memo } from "react";
import styled from "styled-components";
import icon_info_warning_dialog from "assets/icon_info_warning_dialog.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ModalWarning = memo(({ className, onCancel, isOpen, isContent }) => {
  const { t } = useTranslation("translation");
  function getHighlightedText(text, higlight) {
    var parts = text.split(new RegExp(`(${higlight})`, "gi"));
    return parts.map((part, index) => (
      <React.Fragment key={index}>
        {part.toLowerCase() === higlight.toLowerCase() ? (
          <b style={{ color: "#2083DA" }}>{part}</b>
        ) : (
          part
        )}
      </React.Fragment>
    ));
  }

  return (
    <div className={className}>
      <div>
        <div className="flex justify-center items-center mb-5 mt-4">
          <img
            src={icon_info_warning_dialog}
            className="img-menu-logo w-16 mt-5"
            alt="warning"
          />
        </div>
        <div className="text-center font-700 fs-16 ml-4 mr-4">
          {isContent ? t("titleErrorSignUp") : t("titleErrorSignUp1")}
        </div>
        <div className="text-center mb-6 ml-4 mr-4 text-content mt-1">
          {getHighlightedText(
            isContent ? t("contentErrorSignUp2") : t("contentErrorSignUp3"),
            `“19006622”`
          )}
        </div>
        <div className={"flex justify-center mt-4 items-center mb-2"}>
          <div
            onClick={onCancel}
            className="btn_skip w-1/2 font-500 py-3 mx-2 fs-14 mb-5 ml-4"
          >
            {t("back")}
          </div>
          <Link
            to="tel:19006622"
            className="btn_ok w-1/2 font-500 py-3 mx-2 fs-14 mb-5 mr-4"
          >
            {t("callNow")}
          </Link>
        </div>
      </div>
    </div>
  );
});

export default styled(ModalWarning)`
  .text-content {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #808080;
    font-family: "Manrope", sans-serif;
  }
  .btn_ok {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    font-family: "Manrope", sans-serif;
  }
`;
